// Some managed-Chrome security/DLP extensions inject a page-context script that
// wraps native constructors, breaking `class … extends Error`: instances come
// back without their subclass prototype, so `instanceof` and prototype getters
// like `HTTPError._isNominal` — which the app's error handling and Sentry noise
// gates rely on — fail. A runtime that can't subclass Error can't be reliably
// instrumented, so its output is dropped rather than reported as app faults.

let broken: boolean | undefined;

export function hasBrokenErrorSubclassing(): boolean {
  if (broken === undefined) {
    try {
      class Probe extends Error {}
      broken = !(new Probe() instanceof Probe);
    } catch {
      // A runtime where even defining the subclass throws is as broken as one
      // with the wrong prototype; memoizing true also stops it re-throwing.
      broken = true;
    }
  }
  return broken;
}
